// Avoid `console` errors in browsers that lack a console.
(function() {
	var method;
	var noop = function noop() {};
	var methods = [
		'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
		'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
		'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
		'timeStamp', 'trace', 'warn'
	];
	var length = methods.length;
	var console = (window.console = window.console || {});

	while (length--) {
		method = methods[length];

		// Only stub undefined methods.
		if (!console[method]) {
			console[method] = noop;
		}
	}
}());

if (window.navigator && window.navigator.userAgent) {
	if (window.navigator.userAgent.indexOf('Firefox') !== -1 || window.navigator.userAgent.indexOf('Chrome') !== -1) {
		console.log(
			'%c                                                                                                    \n' +
			'                                                                                                    \n' +
			'     `ddhhdh-      +Mm      -ddddh       dM+   sMmyyhdN       /.       NM:                          \n' +
			'     sMmyyhdNd+`   +Mm    -ymNdhdNmy-    dM+                 `my       NM:                          \n' +
			'     sMs    -hMh`  +Mm   /NN+`   `+dh-   dM+                `hMMo      NM:                          \n' +
			'     sMs     `NM/  +Mm   NM+   +oooooo   dM+                sMshM/     NM:                          \n' +
			'     sMs     .NM:  +Mm   mMo    +++dMm   dM+               +Mh .mN:    NM:                          \n' +
			'     sMy   ./mNs   +Mm   -mMs     sNm-   dM+              /MM   sMm.   NM/                          \n' +
			'     oNmh./dds:    /Nd    `+hmdddmh+`    hN+             .mmsssssyNh`  mNd                          \n' +
			'     oNmhhh./      /Nd     \+ddddh./      hN+             .mmsssssyNh`  mNddddd+-                    \n' +
			'                                                                                                    \n' +
			'     oddhhdho-   `dddddddy   hddhddy+`   sd:   `hd-  :ddhhddy:    dd-       sd+    `/sddddho-       \n' +
			'     sMy..-+NN/  `NM/----.  `mM+Md-sMm.  hM/   `NM-  :Mm.../MN-   NM:       hMs   :dNh/--:omNy`     \n' +
			'     sMs    yMh  `NM-       `mM/   `NM/  hM/   `NM-  :MN:::sMm.   NM:       hMs  .NM+      `dMs     \n' +
			'     sMh::/sNm-  `NMmmmmm-  `mMo::/hMh`  hM/   `NM-  :MNyyydMd-   NM:       hMs  -MM`       oMm     \n' +
			'     sMmyyhMm.   `NM:....   `mMhyyyo-`   hMo   .NM-  :Mm   `hMy   NM:       hMs  `hMy.     :NM+     \n' +
			'     sMy  `sMh`  `NMysssso  `mM:         -mMhosmNo   :MN+++yNN:   NMyoooo-  hMs   `oNNhsosdNd:      \n' +
			'     :o:    +o:   oooooooo   +o.          `-+oo/`    .oooooo/`    ooooooo:  /o:     `-+oso+-        \n' +
			'                                                                                        dNNNNNNd`   \n' +
			'                                                                                                    \n' +
			'%c                                                                                                    \n' +
			'                                     MADE IN MELBOURNE                                              \n' +
			'                                                                                                    \n' +
			'%c                                                                                                    \n' +
			'     Instagram:                                LinkedIn:                                            \n' +
			'     https://instagram.com/digitalrepubliq     https://au.linkedin.com/company/digital-republiq     \n' +
			'                                                                                                    \n',
			'background: #1a191b; color: #fff;',
			'background: #fff; color: #1a191b;',
			'background: #1a191b; color: #fff;'
		);
	}
}
